import { render, staticRenderFns } from "./NotificationsListing.vue?vue&type=template&id=77769353&scoped=true&"
import script from "./NotificationsListing.vue?vue&type=script&lang=js&"
export * from "./NotificationsListing.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsListing.vue?vue&type=style&index=0&id=77769353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77769353",
  null
  
)

export default component.exports